import { render } from "./salesHistoryList.vue?vue&type=template&id=ac97d362"
import script from "./salesHistoryList.vue?vue&type=script&lang=js"
export * from "./salesHistoryList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__